module.exports = __webpack_public_path__ + "static/media/empty.892a7295.png";